import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductFeedback } from "../../store/actions/store";
import { CircularProgress, SwipeableDrawer } from "@material-ui/core";
import Carousel from "react-material-ui-carousel";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import FeedbackCard from "../Branches/Feedbacks/FeedbackCard";
import ReviewDrawerContent from "../Branches/ReviewDrawerContent";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import FeedBacksModal from "../Branches/Feedbacks/FeedBacksModal";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import Button from "@material-ui/core/Button";

const ProductReview = ({ productID, categoryID, parentID }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const language = useSelector((state) => state.store.language);
  const themeColor = useSelector((state) => state.store.store.settings?.dark);

  const [open, setOpen] = React.useState(false);
  const [width, setWidth] = React.useState(0);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);

  const productFeedback = useSelector(
    (state) => state.store.current_product?.feedback
  );
  const { customer, settings, user, pastOrders } = useSelector((state) => ({
    settings: state.store.store.settings,
    customer: state.customers.customerContact,
    user: state.auth.user,
    pastOrders: state.PastOrders.pastOrders,
  }));

  useEffect(() => {
    const fetchProductFeedbackEffect = async (productID, categoryID) => {
      setLoading(true);
      await dispatch(fetchProductFeedback(productID, categoryID, 1, parentID));
      setLoading(false);
    };
    if (productFeedback === undefined || productFeedback?.length === 0) {
      fetchProductFeedbackEffect(productID, categoryID);
    }
  }, [dispatch, parentID, productID, categoryID]);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const showFeedback =
    !settings.enable_product_feedback_for_customers_only ||
    pastOrders.length > 0;

  return (
    <>
      {open && (
        <FeedBacksModal
          feedbacks={productFeedback}
          handleOpen={handleOpen}
          handleClose={handleClose}
          open={open}
          width={width}
          productID={productID}
          categoryID={categoryID}
          parentID={parentID}
        />
      )}
      <SwipeableDrawer
        anchor="bottom"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          style: { minHeight: 100, height: "auto" },
          className: "text-center",
        }}
        onBackdropClick={() => setDrawerOpen(false)}
      >
        <ReviewDrawerContent
          closeDrawer={() => setDrawerOpen(false)}
          onSendSuccess={() => setAlertOpen(true)}
          productID={productID}
        />
      </SwipeableDrawer>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={() => setAlertOpen(false)}
        classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
      >
        <Alert onClose={() => setAlertOpen(false)} severity="success">
          {language === "english"
            ? "Your review has been sent successfully!"
            : "تم ارسال التقييم بنجاح!"}
        </Alert>
      </Snackbar>
      {!showFeedback && productFeedback?.length === 0 ? null : (
        <div
          className={"mx-3 mt-4"}
          style={{
            fontWeight: "bold",
            display: "flex",
            cursor: "pointer",
            justifyContent: "space-between",
            flexDirection: language === "arabic" ? "row-reverse" : "row",
          }}
        >
          <p
            style={{
              margin: 0,
            }}
          >
            {language === "arabic" ? "آراء العملاء" : "Customer reviews"}
          </p>
          {productFeedback?.length > 0 && (
            <span
              style={{
                color: themeColor,
                fontWeight: "bold",
              }}
              onClick={handleOpen}
            >
              {language === "arabic" ? "عرض المزيد" : "View more"}
            </span>
          )}
        </div>
      )}

      {productFeedback === undefined || productFeedback?.length === 0 ? (
        loading ? (
          <div
            style={{ display: "flex", justifyContent: "center", padding: 15 }}
          >
            <CircularProgress style={{ color: themeColor }} />
          </div>
        ) : (
          showFeedback && (
            <div
              className="w-100 text-center border-top py-3 mb-1 bordered"
              style={{
                backgroundColor: "white",
                textAlign: "center",
                height: 60,
              }}
            >
              <Button
                color="primary"
                onClick={() => setDrawerOpen(true)}
                endIcon={language === "english" && <ThumbUpIcon />}
                startIcon={
                  language === "arabic" && (
                    <ThumbUpIcon style={{ transform: "scaleX(-1)" }} />
                  )
                }
              >
                {language === "english"
                  ? "Be the first to leave a review"
                  : "كن أول من يترك التعليق"}
              </Button>
            </div>
          )
        )
      ) : (
        <div>
          {loading ? (
            <div
              style={{ display: "flex", justifyContent: "center", padding: 15 }}
            >
              <CircularProgress style={{ color: themeColor }} />
            </div>
          ) : (
            <div>
              <Carousel
                autoPlay={false}
                cycleNavigation={false}
                animation={"slide"}
                indicators={true}
                swipe={true}
                navButtonsAlwaysVisible={true}
                NextIcon={<NavigateNextIcon />}
                PrevIcon={<NavigateBeforeIcon />}
                navButtonsProps={{
                  style: {
                    padding: 5,
                    background: themeColor,
                    color: "white",
                    borderRadius: "50%",
                  },
                }}
              >
                {productFeedback?.slice(0, 5).map((feedback) => (
                  <FeedbackCard
                    setWidth={setWidth}
                    key={feedback.id}
                    feedback={feedback}
                    width={width}
                  />
                ))}
              </Carousel>
              {showFeedback && (
                <p
                  className="pointer"
                  style={{
                    textAlign: language === "english" ? "right" : "left",
                    position: "relative",
                    top: -20,
                    marginRight: language === "english" ? 10 : 0,
                    marginLeft: language === "english" ? 0 : 10,
                    color: themeColor,
                    fontWeight: "bold",
                  }}
                  onClick={() => setDrawerOpen(true)}
                >
                  {language === "english" ? "Leave review" : "ملاحظات او تقييم"}
                </p>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ProductReview;
